const Telchan = {
  env: 'development',
};
export{Telchan};
